import api from '../../../../libs/api';
import { gridHelper } from '../../../../libs/grid';
import configQueryReactSimpleRequest from '../../config/configQuery';
import { FieldMapping } from '../../../../libs/grid/gridHelper';
import { useAppSelector } from '../../../core/store';
import * as settings from '../../hooks/useSettings';
import moment from 'moment';
import { State } from '@progress/kendo-data-query';
import { useServerGridDataHandler, useGridV2 } from '../../../../Hooks/useKendoGrid';

const fieldMapping: FieldMapping[] = [
    { frontFieldName: 'startDate', backFieldName: 'AsiteDocumentsSyncLog.StartDate' },
    { frontFieldName: 'endDate', backFieldName: 'AsiteDocumentsSyncLog.EndDate' },
    { frontFieldName: 'status', backFieldName: 'AsiteDocumentsSyncLog.Status' },
    { frontFieldName: 'message', backFieldName: 'AsiteDocumentsSyncLog.Message' },
    { frontFieldName: 'emailSend', backFieldName: 'AsiteDocumentsSyncLog.EmailSend' }
];

const fetchAsiteSyncLogs = (gridState: any, startDateValue: Date | undefined, endDateValue: Date | undefined) =>
    api.post('/api/v2/AsiteRelaticsSync/GetAsiteSyncLogs', {
        safe: true,
        params: { startDate: startDateValue, endDate: endDateValue },
        data: gridHelper.getRequestPayloadFromQueryState(gridState, fieldMapping)
    });

const useAsiteSyncLogsGrid = (gridState: State, setGridState: React.Dispatch<React.SetStateAction<State>>) => {
    const startDate = useAppSelector(settings.selectors.getStartDate);
    const endDate = useAppSelector(settings.selectors.getEndDate);

    const { gridResult, gridQuery } = useGridV2({
        query: {
            queryKey: ['get-asite-logs', startDate !== undefined ? moment(startDate).format() : '', endDate !== undefined ? moment(endDate).format() : ''],
            queryFn: fetchAsiteSyncLogs,
            queryOptions: configQueryReactSimpleRequest,
        },
        transform: (item) => ({
            ...item,
            startDate: new Date(item.startDate),
            endDate: item.endDate ? new Date(item.endDate): ''
        }),
        gridState,
        setGridState
    });

    const handleDataStateChange = useServerGridDataHandler({ gridState, setGridState, gridQuery });
    
    return { AsiteSyncLogsQuery: gridQuery, gridState, gridResult, handleDataStateChange };
};

export default useAsiteSyncLogsGrid;
